import classNames from 'classnames';

import styles from './Grid.module.scss';

export interface GridProps {
	className?: string;
	wrap?: boolean;
	container?: boolean;
	nogutter?: boolean;
	center?: boolean;
	full?: boolean;
	rowGap?: boolean;
	spaceBetween?: boolean;
	children?: React.ReactNode;
}

export const Grid: React.FC<GridProps> = ({ wrap, container, nogutter, center, full, rowGap, spaceBetween, children, className }) => (
	<div
		className={classNames(
			styles.Grid,
			{ [styles.Grid___wrap]: wrap },
			{ [styles.Grid___container]: container },
			{ [styles.Grid___noGutter]: nogutter },
			{ [styles.Grid___center]: center },
			{ [styles.Grid___full]: full },
			{ [styles.Grid___rowGap]: rowGap },
			{ [styles.Grid___spaceBetween]: spaceBetween },

			className,
		)}
	>
		{children}
	</div>
);
